import UltMeta, { Meta } from "./UltMeta/index";
/**
 * 提货状态
 */
class DeliveryState extends UltMeta {
    TO_BE_INITIATED = new Meta(6, "待发起");
    TO_BE_CONFIRMED = new Meta(1, "待确认");
    CONFIRMED = new Meta(2, "已确认");
    PICKED_UP = new Meta(3, "已提货");
    CANCELED = new Meta(4, "已取消");
}

export const DELIVERY_STATE = new DeliveryState();

/**
 * 提货状态 PC
 */
class DeliveryStatePC extends UltMeta {
    TO_BE_CONFIRMED = new Meta(1, "待确认");
    CONFIRMED = new Meta(2, "已确认");
    PICKED_UP = new Meta(3, "已提货");
    CANCELED = new Meta(4, "已取消");
}

export const DELIVERY_STATE_PC = new DeliveryStatePC();

/**
 * 新数据标识
 */
class NewDataFlag extends UltMeta {
    NO = new Meta(0, "否");
    YES = new Meta(1, "是");
}

export const NEW_DATA_FLAG = new NewDataFlag();

/**
 * 提货类型
 */
class DeliveryType extends UltMeta {
    /**
     * 排期产生
     */
    SCHEDULE_GENERATION = new Meta(1, "排期产生");
    /**
     * 手动新增
     */
    MANUAL_ADDITION = new Meta(2, "手动新增");
}

export const DELIVERY_TYPE = new DeliveryType();
